import { render, staticRenderFns } from "./users-stats.vue?vue&type=template&id=1237f6ee&scoped=true"
import script from "./users-stats.vue?vue&type=script&lang=js"
export * from "./users-stats.vue?vue&type=script&lang=js"
import style0 from "./users-stats.vue?vue&type=style&index=0&id=1237f6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237f6ee",
  null
  
)

export default component.exports